$(document).ready(function () {

    // logolist slider start

     var swiper = new Swiper(".mySwiper.logolist-slider", {
        loop:true,
        spaceBetween: 16,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        speed:4000,
        breakpoints: {
          0: {
            slidesPerView: 1,
            speed: 4000,
          },
          500: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          }
        },
    });

  //---------------- changing font-family ----------------
   $('.about').find('.about__accordion-item  span').attr('style','font-family: Inter, sans-serif !important; font-style: normal;')
   $('.about').find('.about__accordion-item  strong').attr('style','font-style: normal;')
  
  
  
    // logolist slider end

    // search js start
   // $('span.drawer_icon-search').click(function(){
   //    $('.search_input-show, .search_input-show .header__search.search').css("display","block");
   //     $('.header__overlay').addClass('visible');
   //   $('.header-wrapper .header__top-inner.container').css("z-index","-1");
   //   $('.header__overlay').css("top","80px");
   //  });
  
   // $('.search_input-show button.search__button.field__button').click(function(){
   //    $('.header__overlay').removeClass('visible');
   //   $('.search_input-show, .search_input-show .header__search.search').css("display","none");
   //    $('.header-wrapper .header__top-inner.container').css("z-index","0");
   // });
    // search js end
  
    // drawer start
   $(".header-wrapper details.menu-drawer-container").click(function(){
       $("body").addClass("remove_will");
    $(document).find("body.remove_will .shopify-section-header").css("will-change","transform");
  });
   $(document).on("click", ".cross-icon", function () {
     $("body").removeClass("remove_will");
    // $(document).find("body .shopify-section-group-header-group.shopify-section-header").css("will-change","inherit");
  });

    $(".cross-icon").click(function (){
      $(".menu-drawer-container.itg_drawer").removeClass("menu-opening").removeAttr("open");
      $("body").removeClass("overflow-hidden-tablet");
    });
    $(".header__icon svg.icon-drawer-header").click(function (){
     $('.header__modal-close-button').css("display","none");
    });
    $(".cross-icon").click(function (){
     $('.header__icon svg.icon-drawer-header').css("display","block");
    });
    // drawer end

/*Product recommendation slider start*/
$(window).scroll(function(){
   var swiper = new Swiper(".mySwiper.cstm-recommendation", {
      cssMode: false,
      slidesPerView: 5,
      spaceBetween: 16,
      navigation: {
        nextEl: ".slider-recommendation.next",
        prevEl: ".slider-recommendation.prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          1140: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
        },
      mousewheel: false,
      keyboard: true,
    });
 
 });
/*Product recommendation slider end*/

// left menu 
$("ul.list-menu.list-menu--inline li.smt-nav").mouseenter(function () {
    var width = $(this).width();
    var position = $(this).offset();
    $("span.main-navigation__underline.absolute").css({ "left": position.left , "width": width }) ;  
});
$("ul.list-menu.list-menu--inline li.smt-nav").mouseleave(function () {
    $("span.main-navigation__underline.absolute").css({ "left": "0px" , "width": "100%" }) ; 
});

// right menu
$(".vertical_menus li").mouseenter(function () {
     var width = $(this).width();
    var position = $(this).offset();
     var titleContent = $(this).data('title');
    $('.header-wrapper').addClass(titleContent);
    $("span.main-navigation__underline.absolute").css({ "left": position.left , "width": width }) ;  
});
$(".vertical_menus li").mouseleave(function () {
    var titleContent = $(this).data('title');
    $('.header-wrapper').removeClass(titleContent);
    $("span.main-navigation__underline.absolute").css({ "left": "0px" , "width": "100%" }) ; 
});

  //Cart drawer js start
$("#cart-icon-bubble").bind("DOMSubtreeModified", function() {
  if ($('body').hasClass('activeCART')) {
    
  } else {
  
    $.ajax({
        url: "/cart",
        type: "GET",
        dataType: "html",
        success: function (data) {
            var cartHTml = $(data).find('#cart-icon-bubble').html();
            $(document).find('#cart-icon-bubble').html(cartHTml);
          $('body').addClass('activeCART')
        },
        error: function (xhr, status) {
        },
        complete: function (xhr, status) {
            //$('#showresults').slideDown('slow')
        }
    });
  }
   setTimeout(function(){
      $('body').removeClass('activeCART')
    }, 4000);
});
//Cart drawer js end
  
// product page metacontent slider start
    const mySwiper = new Swiper('.features_image_text-mobile', {
      loop: false,
      slidesPerView: 1.2,
      spaceBetween: 10,
    });
// product page metacontent slider end

// banner read more start
  var width = $(window).width();
  if(width <= 425){
      var showChar = 180;  // How many characters are shown by default
      var ellipsestext = "";
      var moretext = "Read More";
      var lesstext = "Read Less";
      
      $('.image-banner__text').each(function() {
          var content = $(this).html();
         
          if(content.length > showChar) {
   
              var c = content.substr(0, showChar);
              var h = content.substr(showChar, content.length - showChar);
   
              var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';
   
              $(this).html(html);
          }
   
      });
   
      $(".morelink").click(function(){
          if($(this).hasClass("less")) {
              $(this).removeClass("less");
              $(this).html(moretext);
          } else {
              $(this).addClass("less");
              $(this).html(lesstext);
          }
          $(this).parent().prev().toggle();
          $(this).prev().toggle();
          return false;
      });
    }
// banner read more end

  //brand  logo js start
  $('#vendorList ul').listnav({
     initLetter: 'A', // Show all vendors initially
    includeAll: true, // Include 'All' in the navigation
    includeNums: true, // Exclude numbers from navigation
    noMatchText: 'No brands found' // Text to display when no match found
   
  });

  // $("#-nav a").click(function () {
    $(document).on('click touchend','#-nav a', function(){
     
    // });
       if ($("#-nav a").hasClass('ln-selected')){}
             var gettext = $('#-nav a.ln-selected').text();
             $("#select_character").text(gettext);
    });  
//Brand logo js end

//Copy link js start  
$('.copy_link_button').click(function(){
   var wap = $(this).attr("id");
  // console.log(wap);
  $('.template-product span.coply_url').css("display","block");
});
$(".copy_link_button").mouseleave(function(){
  $(".template-product span.coply_url").css("display", "none");
});
//Copy link js end 

// help & advice desktop start
        $( ".help_adviceBtn , .headphone_popup, #helpAndAdviceButton" ).click(function() {
          $(".help_overlay_desktop").fadeIn("slow");
        $(".help-advice-content-section_desk").css("transform","translate(0)");
      });
      $(".help-advice-content-section_desk .cross-icon_show, .help_overlay_desktop").click(function(){
        $(".help_overlay_desktop").fadeOut("slow");
        $(".help-advice-content-section_desk").css("transform","translate(110%)");
      });
  // help & advice desktop end

// rendering js start
  $('body').css('opacity', '1');
// rendering js end

//specification js start
$('.json_data.title_key .title-accordian').click(function(){
      var Tab = $(this).attr('id');
    $('.specification_alt').each(function(){
        var Details = $(this).attr('data-id');
     
        if (Tab == Details){
            $(this).slideToggle();
            $(this).parent().toggleClass('active');
        }
        else {
            $(this).slideUp();
            $(this).parent().removeClass('active');
        }
    });
});
//specification js end

//Warrenty specification read more js start

  var showChars = 617;  // How many characters are shown by default
      var ellipsestexts = "";
      var moretexts = "Read More";
      var lesstexts = "Read Less";
      
      $('.additional_content_specification p:first-child').each(function() {
          var content = $(this).html();
         
          if(content.length > showChars) {
   
              var c = content.substr(0, showChars);
              var h = content.substr(showChars, content.length - showChars);
   
              var html = c + '<span class="moreellipses">' + ellipsestexts+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morlink">' + moretexts + '</a></span>';
   
              $(this).html(html);
          }
   
      });
   
      $(".morlink").click(function(){
          if($(this).hasClass("less")) {
              $(this).removeClass("less");
              $(this).html(moretexts);
          } else {
              $(this).addClass("less");
              $(this).html(lesstexts);
          }
          $(this).parent().prev().toggle();
          $(this).prev().toggle();
          return false;
      });
//Warrenty specification read more js end

//Help and advice using ajax start
$( window ).on( "load", function() {
    //e.preventDefault();
    var data_page = $('.header__top .help_adviceBtn a[href="javascript:void(0)"], .header__top .headphone_popup a[href="javascript:void(0)"]').attr('data-page');
  //alert(data_page);
    $.ajax({
        type: 'GET',
        url: data_page,
        dataType: 'html',
        success: function (data) {
          var page_content = $(data).find('.cstm_page').html();
          $(document).find('.help-advice-content-section_desk .wrapper_icon_cancle_show  .page_content, .help-advice-content-section .page_content').html(page_content);
          //$('body').css('overflow', 'hidden');
        },
        error: function (status) {
            // console.log(status);
        }
    });
  });

  //Help and advice using ajax end

// bonus box js start
  var iconText = $(".bonus_box .info-icon-mian").html();
  var bonusHead = $(".bonus_box p:first-child").html();
    $(".bonus_box .info-icon-mian").text("");
    $(".bonus_box p:first-child").html('');
    $(".bonus_box p:first-child").html(bonusHead +''+ iconText);
// bonus box js end

// wishlist count (0) start
  $(".wishlisthero-header-block .wishlist-hero-header-icon").on('click',function(){         
         $('body').addClass('datashowswish');
    }); 
  
    $( window ).on( "load", function() {
      setTimeout(function() {
        if ($('span.wishlist-hero-items-count.wishlist-hero-items-count-text, .wishlistPage span.wishlist-hero-items-count.wishlist-hero-items-count-text-plain.cart-count-bubble').css('display') == 'none') {
              $('span.wishlist-hero-items-count.wishlist-hero-items-count-text').text('(0)').css("display","inline-block");
              $('.wishlistPage span.wishlist-hero-items-count.wishlist-hero-items-count-text-plain.cart-count-bubble').text('(0)').css("display","flex")
        }
      }, 50);
     });
    
    $('.itg_add_wishlist').click(function () { span.wishlist-hero-items-count.wishlist-hero-items-count-text-plain.cart-count-bubble
        setTimeout(function () {
                if ($('span.wishlist-hero-items-count.wishlist-hero-items-count-text').css('display') == 'none') {
                  $('span.wishlist-hero-items-count.wishlist-hero-items-count-text').text('(0)').css("display","inline-block");
                }
          }, 2000);
    });
  
    $(document).on("click", ".wishlist-hero-list-card-footer-delete-all",function () {
         setTimeout (function() {
            if ($('span.wishlist-hero-items-count.wishlist-hero-items-count-text').css('display') == 'none') {
                  $('span.wishlist-hero-items-count.wishlist-hero-items-count-text').text('(0)').css("display","inline-block");
            }
         },2000);
    });
    $(document).on("click", ".wishlist-hero-list-card-footer-delete",function () {
         setTimeout (function() {
            if ($('span.wishlist-hero-items-count.wishlist-hero-items-count-text').css('display') == 'none') {
                  $('span.wishlist-hero-items-count.wishlist-hero-items-count-text').text('(0)').css("display","inline-block");
            }
         },2000);
    });
    $(document).on("click", ".wishlist-hero-header-close",function () {
         setTimeout (function() {
            if ($('span.wishlist-hero-items-count.wishlist-hero-items-count-text').css('display') == 'none') {
                  $('span.wishlist-hero-items-count.wishlist-hero-items-count-text').text('(0)').css("display","inline-block");
            }
         },1000);
    });
    $(document).on("click", ".MuiBackdrop-root",function () {
         setTimeout (function() {
            if ($('span.wishlist-hero-items-count.wishlist-hero-items-count-text').css('display') == 'none') {
                  $('span.wishlist-hero-items-count.wishlist-hero-items-count-text').text('(0)').css("display","inline-block");
            }
         },1000);
    });
  var wishlistItemCount = $('.wishlist-hero-items-count.wishlist-hero-items-count-text-plain.cart-count-bubble.wishlist-hero-items-count-exists').text();
    
    // Append the value to another element
    $('#targetElement').append(wishlistItemCount);
// wishlist count (0) end

  //bnpl js start
  // $(document).on("click", ".SwymGrLatitudeBtn", function() {
  //   $(document).find(".latitude img.latitude_img").addClass("Clicked").trigger("click");
  // });
  $(document).on("click", "span.zip_opner", function(){
    $(document).find("span#shopify-zip-prod-widget").trigger("click");
  });
  $(document).on("click", "span.humm_opner", function(){
    $(document).find(".humm-price-info-widget .humm-description .humm-main .nowrap").trigger("click");
  });

  
  var width = $(window).width();
  if(width > 768 ){
      // for custom paypal 
      $(document).on("click", ".bnpl-section .paypal", function(){
        $(document).find(".paypal_popup").fadeIn();
        $(document).find(".paypal_overlay").fadeIn();
        // $("body").addClass("cstmOverlay");
      });
      $(document).on("click", ".paypal-col span, .paypal_overlay", function(){
        $(document).find(".paypal_popup").fadeOut();
        $(document).find(".paypal_overlay").fadeOut();
        // $("body").removeClass("cstmOverlay");
      });
    
        /*js start for latitude popup*/
      $(".wrapper_zip_humm.latitude span.latitude_learn").click(function(){
        $("body").css("overflow","hidden");
        $(".overlay_latitude, .latitude-tndc").fadeIn("slow");
      });
      $(".cancle_icon_latitude, .overlay_latitude").click(function(){
        $("body").css("overflow","scroll");
        $(".overlay_latitude, .latitude-tndc").fadeOut("slow");
      });
    
      $(".wrapper_zip_humm.latitude .SwymGrLatitudeBtn").click(function(){
        $("body").css("overflow","hidden");
        $(".latutide_main-popup, .latutide_main-popup-overlay").fadeIn();
      });
      $(".cancle_icon_latitude-main, .latutide_main-popup-overlay").click(function(){
        $("body").css("overflow","scroll");
        $(".latutide_main-popup, .latutide_main-popup-overlay").fadeOut();
      });
      /*js end for latitude popup*/
  }
  else{
      // for custom paypal 
      $(document).on("click", ".bnpl-section .paypal", function(){
        $(document).find(".paypal_popup").css("right","0px");
         // $("body").addClass("overlay");
      });
      $(document).on("click", ".paypal-col span, .paypal_overlay", function(){
         $(document).find(".paypal_popup").css("right","-100%");
            // $("body").addClass("overlay");
      });
    
      /*js start for latitude popup*/
      $(".wrapper_zip_humm.latitude span.latitude_learn").click(function(){
        $("body").css("overflow","hidden");
        $(".overlay_latitude, .latitude-tndc").css("right","0px");
      });
      $(".cancle_icon_latitude, .overlay_latitude").click(function(){
        $("body").css("overflow","scroll");
        $(".overlay_latitude, .latitude-tndc").css("right","-100%");
      });

      $(".wrapper_zip_humm.latitude .SwymGrLatitudeBtn").click(function(){
        $("body").css("overflow","hidden");
        $(".latutide_main-popup, .latutide_main-popup-overlay").css({"transform": "translateX(0)"});
      });
      $(".cancle_icon_latitude-main, .latutide_main-popup-overlay").click(function(){
        $("body").css("overflow","scroll");
        $(".latutide_main-popup, .latutide_main-popup-overlay").css({"transform": "translateX(100%)"});
      });
      /*js end for latitude popup*/
      
  }
  //bnpl js end

/*mega-menu js start*/
$("ul.list-menu.list-menu--inline li.smt-nav").mouseenter(function() {
    var wap = $(this).attr('list-title');
     $('.cstm-mega-menu-display .mega-menu-list-itg').each(function(){
      var alp = $(this).attr('data-title');
          if (wap == alp){
              $(this).addClass("display");
          }
          else {
           $(this).removeClass("display");
          }
      });
});

$("ul.list-menu.list-menu--inline li.smt-nav").mouseleave(function() {
    $('.cstm-mega-menu-display .mega-menu-list-itg').removeClass("display");
});

$('.cstm-mega-menu-display .mega-menu-list-itg').mouseenter(function() {
    $(this).addClass("display");
});
$('.cstm-mega-menu-display .mega-menu-list-itg').mouseleave(function() {
    $(this).removeClass("display");
});


  
$(".cstm-mega-menu-display ul.vertical_menus-loop.parent-child li.childMenu").mouseenter(function () {
      if($(this).find('ul.mega-menu__list.list-unstyled.focus-inset.childer-navigation').length){
          var height = $(this).find('ul.mega-menu__list.list-unstyled.focus-inset.childer-navigation').height();
          $(this).parents(".mega-menu-list-itg").css({ "min-height": height , "background-color": "#ffffff" });
          setTimeout(()=>{
            var height = $(this).find('ul.mega-menu__list.list-unstyled.focus-inset.childer-navigation').height();
            $(this).parents(".mega-menu-list-itg").css({ "min-height": height , "background-color": "#ffffff" });
          },10);
      }
      else{
        $(this).parents(".mega-menu-list-itg").css({ "min-height": 'unset' });
      }
});
$(".mega-menu-list-itg").mouseleave(function(){
        $(this).css({ "min-height": 'unset' }) ;
});
  
/*mega-menu js end*/
  
});

/*wishlist update js start*/

document.addEventListener("wishlist-hero-wishlist-updated",function(e){

  $("html.js body").css({"overflow": "auto", "padding-right": "0px", "transition":"none !important"});

  $("body").addClass("wishlist_drawer");
   
  $(".wishlist-hero-price-update").addClass("updated_itg");
  setTimeout (function() {
  $(".wishlist-hero-price-update.updated_itg span.money.conversion-bear-money b").addClass("quantity_product");
    },1000);
  
   setTimeout (function() {
  $('.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.MuiGrid-align-items-xs-flex-start:last-child, .wishlisthero-customer-view-listing .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.MuiGrid-align-items-xs-flex-start:last-child').addClass("append_properties")
  },1000);
  
  $('.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.MuiGrid-align-items-xs-flex-start, .wishlisthero-customer-view-listing .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.MuiGrid-align-items-xs-flex-start').append("<div class='smtSubtotal'><p>Subtotal: </p><p class='priceCol'>  </p><p class='shippingText'> Shipping calculated at checkout</p></div>");
  var priceArray = [];
  $(".updated_itg .money.conversion-bear-money").each(function () {
      priceArray.push($(this).attr('data-wlh-item-price').replace("$", "").replace(",", ""));
  });
 
   // Calculate total value
    var totalValue = 0; 
    if(priceArray.length >= 1){
        for (var i = 0; i < priceArray.length; i++) {
            totalValue += parseFloat(priceArray[i]);
        }
    }
    $(document).find('.smtSubtotal .priceCol').text( '$'+totalValue.toLocaleString('en') + ' AUD' );

  // wishlist item count start
    var numItems = $('.MuiGrid-root.wishlist-hero-list-card').length;
    setTimeout (function() {
          $(".MuiDialogTitle-root .MuiTypography-h5.wishlist-hero-header-title b").addClass("totle_item_div")
          $(document).find(".MuiDialogTitle-root .MuiTypography-h5.wishlist-hero-header-title").append("<b>" + numItems + " items</b>");
    },70);
  // wishlist item count end

  //remove zero from price js start
   $('span.money.conversion-bear-money').each(function() {
    let priceText = $(this).text();
    let newPriceText = priceText.replace('.00', '');
    $(this).text(newPriceText);
  });
  //remove zero from pricr js end

  $(document).find(".MuiDialog-scrollPaper .MuiDialogContent-dividers .wishlisthero-customer-view-listing").css("opacity", "1");

/*add to cart js start*/
$(document).on("click", "button.wishlist-hero-list-card-footer-add-all-to-cart-dialog", function () {
  setTimeout(function () {
    $(document).find(".MuiDialogActions-root.MuiDialogActions-spacing button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary").addClass("all-to-cart");
  },1000);

});

$(document).on("click",".MuiDialogActions-root.MuiDialogActions-spacing button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.all-to-cart",function() {
   
          $(".MuiGrid-root.wishlist-hero-list-card").each(function () {
              let prodLink = $(this).find('.wishlist-hero-list-card-header .MuiLink-root.MuiLink-underlineHover.wishlist-hero-list-card-header-product-name').attr("href");
              let prodVariantId = prodLink.substring(prodLink.indexOf("=") + 1);
            
              fetch(`/variants/${prodVariantId}.js`)
              .then(response => response.json())
              .then(variant => {
              
              const inventoryAvailable = variant.available;
                
                if(inventoryAvailable){
                          $(this).find(".MuiButtonGroup-root .wishlist-hero-list-card-footer-delete").trigger("click");
                        setTimeout(function () {
                             $(document).find("button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary").trigger("click");
                        },20);
                  }
                   
              });

          });

            setTimeout(function () {
                  $(this).removeClass("remove");
                  $(document).find(".wishlist-hero-header-close").trigger("click");
            },800);

    $("body").removeClass("wishlist_drawer");
    $('#cart-icon-bubble').load(location.href + (' #cart-icon-bubble'));
    $('#CartDrawer').load(location.href + (' #CartDrawer'));
    openDrawer();
});

   function openDrawer() {
      setTimeout(function(){
        $('.drawer').addClass('active');
        $('.drawer').removeClass('is-empty');
      }, 2000);
    }

  $(document).on("click","button.MuiButtonBase-root.MuiIconButton-root.jss6.wishlist-hero-header-close",function() {
    $(".MuiDialog-container.MuiDialog-scrollPaper").addClass("opacity_show");
     $("body").removeClass("wishlist_drawer");
  });
 /*add to cart js end*/ 
});
/*wishlist update js end*/